import './App.css';
import React from "react";
import Wheel from './Wheel';




class App extends React.Component {


  render(){
  return (
    <>

<Wheel/>
      
      


    </>
  );

}
}

export default App;
